var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSprite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-eye",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.88,
    d: "M1.333 16c0 0 5.333-10.667 14.667-10.667s14.667 10.667 14.667 10.667-5.333 10.667-14.667 10.667c-9.333 0-14.667-10.667-14.667-10.667z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.88,
    d: "M16 20c2.209 0 4-1.791 4-4s-1.791-4-4-4c-2.209 0-4 1.791-4 4s1.791 4 4 4z"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-eye-off",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.88,
    d: "M23.92 23.92c-2.279 1.737-5.055 2.7-7.92 2.747-9.333 0-14.667-10.667-14.667-10.667 1.659-3.091 3.959-5.791 6.747-7.92M13.2 5.653c0.918-0.215 1.857-0.322 2.8-0.32 9.333 0 14.667 10.667 14.667 10.667-0.809 1.514-1.775 2.94-2.88 4.253M18.827 18.827c-0.366 0.393-0.808 0.708-1.299 0.927s-1.020 0.336-1.557 0.346c-0.537 0.009-1.071-0.089-1.569-0.291s-0.95-0.501-1.33-0.88c-0.38-0.38-0.679-0.832-0.88-1.33s-0.3-1.032-0.29-1.569c0.009-0.537 0.127-1.067 0.346-1.558s0.534-0.932 0.927-1.298"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.88,
    d: "M1.333 1.333l29.333 29.333"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-success",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3cbf61",
    style: {
      fill: "var(--color1, #3cbf61)"
    },
    d: "M16 29.333c-7.364 0-13.333-5.969-13.333-13.333s5.969-13.333 13.333-13.333c7.364 0 13.333 5.969 13.333 13.333s-5.969 13.333-13.333 13.333zM14.459 21.98l9.427-9.428-1.885-1.885-7.541 7.543-3.772-3.772-1.885 1.885 5.657 5.657z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-error",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d80027",
    style: {
      fill: "var(--color1, #d80027)"
    },
    d: "M16 29.333c-7.364 0-13.333-5.969-13.333-13.333s5.969-13.333 13.333-13.333c7.364 0 13.333 5.969 13.333 13.333s-5.969 13.333-13.333 13.333zM14.459 21.98l9.427-9.428-1.885-1.885-7.541 7.543-3.772-3.772-1.885 1.885 5.657 5.657z"
  })), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-warning",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M16 25.333v0.013M16 20v-13.333"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-add-avatar",
    viewBox: "0 0 33 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e6533c",
    style: {
      fill: "var(--color3, #e6533c)"
    },
    d: "M11.238 0.428l4.69 1.356c0.339 0.098 0.699 0.099 1.038 0.002l4.83-1.375c0.845-0.241 1.744 0.136 2.166 0.906l2.506 4.577c0.168 0.307 0.419 0.561 0.723 0.734l3.986 2.258c0.771 0.437 1.133 1.352 0.869 2.198l-1.381 4.428c-0.113 0.363-0.114 0.752-0.002 1.115l1.394 4.521c0.258 0.836-0.094 1.739-0.849 2.18l-4.443 2.597c-0.303 0.177-0.551 0.436-0.715 0.746l-2.114 4.004c-0.409 0.775-1.298 1.165-2.145 0.941l-4.863-1.284c-0.317-0.084-0.651-0.083-0.968 0.002l-4.715 1.264c-0.867 0.232-1.777-0.179-2.175-0.983l-2.106-4.256c-0.177-0.357-0.462-0.649-0.816-0.834l-4.304-2.247c-0.786-0.411-1.179-1.314-0.943-2.169l1.255-4.548c0.089-0.322 0.090-0.662 0.005-0.985l-1.288-4.843c-0.221-0.833 0.151-1.71 0.904-2.129l4.422-2.46c0.322-0.179 0.584-0.448 0.754-0.775l2.090-4.007c0.414-0.794 1.331-1.187 2.192-0.938z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#efede8",
    style: {
      stroke: "var(--color2, #efede8)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M16.5 10.75v10.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#efede8",
    style: {
      stroke: "var(--color2, #efede8)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M11.25 16h10.5"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-avatar",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#efede8",
    style: {
      fill: "var(--color2, #efede8)"
    },
    opacity: 0.1,
    d: "M16 5.333c1.415 0 2.771 0.562 3.771 1.562s1.562 2.357 1.562 3.771-0.562 2.771-1.562 3.771c-1 1-2.357 1.562-3.771 1.562s-2.771-0.562-3.771-1.562c-1-1-1.562-2.357-1.562-3.771s0.562-2.771 1.562-3.771c1-1 2.357-1.562 3.771-1.562zM16 26.667c0 0 10.667 0 10.667-2.667 0-3.2-5.2-6.667-10.667-6.667s-10.667 3.467-10.667 6.667c0 2.667 10.667 2.667 10.667 2.667z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-calendar-white",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#efede8",
    style: {
      stroke: "var(--color2, #efede8)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M25.333 5.333h-18.667c-1.473 0-2.667 1.194-2.667 2.667v18.667c0 1.473 1.194 2.667 2.667 2.667h18.667c1.473 0 2.667-1.194 2.667-2.667v-18.667c0-1.473-1.194-2.667-2.667-2.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#efede8",
    style: {
      stroke: "var(--color2, #efede8)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M21.333 2.667v5.333"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#efede8",
    style: {
      stroke: "var(--color2, #efede8)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M10.667 2.667v5.333"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#efede8",
    style: {
      stroke: "var(--color2, #efede8)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M4 13.333h24"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-logo",
    viewBox: "0 0 286 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e6533c",
    style: {
      fill: "var(--color3, #e6533c)"
    },
    d: "M80.941 13.714c1.040 0 1.882 0.843 1.882 1.882v0.807c0 1.040-0.843 1.882-1.882 1.882h-2.151c-1.039 0-1.882 0.843-1.882 1.882v5.378c0 1.040-0.843 1.882-1.882 1.882h-2.151c-1.040 0-1.882 0.843-1.882 1.882v0.807c0 1.040-0.843 1.882-1.882 1.882h-5.109c-1.040 0-1.882-0.843-1.882-1.882v-9.95c0-1.040-0.843-1.882-1.882-1.882h-37.647c-1.040 0-1.882 0.843-1.882 1.882v9.95c0 1.040-0.843 1.882-1.882 1.882h-5.109c-1.040 0-1.882-0.843-1.882-1.882v-0.807c0-1.040-0.843-1.882-1.882-1.882h-2.151c-1.040 0-1.882-0.843-1.882-1.882v-5.378c0-1.040-0.843-1.882-1.882-1.882h-2.151c-1.040 0-1.882-0.843-1.882-1.882v-0.807c0-1.040 0.843-1.882 1.882-1.882h2.151c1.040 0 1.882-0.843 1.882-1.882v-5.378c0-1.040 0.843-1.882 1.882-1.882h2.151c1.040 0 1.882-0.843 1.882-1.882v-0.807c0-1.040 0.843-1.882 1.882-1.882h5.109c1.040 0 1.882 0.843 1.882 1.882v9.95c0 1.040 0.843 1.882 1.882 1.882h37.647c1.040 0 1.882-0.843 1.882-1.882v-9.95c0-1.040 0.843-1.882 1.882-1.882h5.109c1.040 0 1.882 0.843 1.882 1.882v0.807c0 1.040 0.843 1.882 1.882 1.882h2.151c1.040 0 1.882 0.843 1.882 1.882v5.378c0 1.040 0.843 1.882 1.882 1.882h2.151z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efede8",
    style: {
      fill: "var(--color2, #efede8)"
    },
    d: "M97.882 29.873v-26.353h9.412c1.431 0 2.723 0.358 3.878 1.073 1.167 0.715 2.089 1.675 2.767 2.88s1.016 2.529 1.016 3.972c0 1.481-0.351 2.824-1.054 4.028-0.69 1.192-1.619 2.146-2.786 2.861-1.167 0.703-2.441 1.054-3.821 1.054h-4.819v10.485h-4.593zM102.475 14.795h4.329c0.653 0 1.249-0.163 1.788-0.489s0.966-0.765 1.28-1.318c0.326-0.552 0.489-1.167 0.489-1.845 0-0.69-0.163-1.311-0.489-1.864-0.314-0.552-0.74-0.991-1.28-1.318s-1.136-0.489-1.788-0.489h-4.329v7.322z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efede8",
    style: {
      fill: "var(--color2, #efede8)"
    },
    d: "M125.393 30.362c-1.732 0-3.313-0.446-4.744-1.336-1.418-0.891-2.554-2.083-3.407-3.576-0.841-1.506-1.261-3.169-1.261-4.988 0-1.38 0.245-2.667 0.734-3.859 0.489-1.205 1.161-2.259 2.014-3.162 0.866-0.916 1.87-1.631 3.012-2.146s2.359-0.772 3.652-0.772c1.732 0 3.307 0.445 4.725 1.336 1.431 0.891 2.566 2.089 3.407 3.595 0.853 1.506 1.28 3.175 1.28 5.007 0 1.368-0.245 2.648-0.734 3.84s-1.167 2.246-2.033 3.162c-0.853 0.904-1.851 1.613-2.993 2.127-1.129 0.514-2.347 0.772-3.652 0.772zM125.393 25.769c0.916 0 1.738-0.245 2.466-0.734s1.299-1.136 1.713-1.939c0.427-0.803 0.64-1.681 0.64-2.635 0-0.979-0.219-1.87-0.659-2.673-0.427-0.816-1.010-1.462-1.751-1.939-0.728-0.489-1.531-0.734-2.409-0.734-0.904 0-1.719 0.245-2.447 0.734s-1.305 1.142-1.732 1.958c-0.427 0.816-0.64 1.7-0.64 2.654 0 0.991 0.22 1.889 0.659 2.692s1.023 1.443 1.751 1.92c0.741 0.464 1.544 0.696 2.409 0.696z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efede8",
    style: {
      fill: "var(--color2, #efede8)"
    },
    d: "M146.566 29.873h-4.555l-6.287-18.824h4.499l4.085 12.179 4.066-12.179h4.536l4.066 12.179 4.085-12.179h4.499l-6.287 18.824h-4.555l-4.085-12.235-4.066 12.235z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efede8",
    style: {
      fill: "var(--color2, #efede8)"
    },
    d: "M175.907 30.362c-1.732 0-3.313-0.446-4.744-1.336-1.418-0.891-2.554-2.089-3.407-3.595-0.841-1.506-1.261-3.169-1.261-4.988 0-1.368 0.245-2.648 0.734-3.84 0.489-1.205 1.161-2.259 2.014-3.162 0.866-0.916 1.87-1.631 3.012-2.146s2.359-0.772 3.652-0.772c1.468 0 2.811 0.314 4.028 0.941 1.23 0.615 2.271 1.462 3.125 2.541s1.474 2.309 1.864 3.689c0.389 1.38 0.477 2.824 0.264 4.329h-13.76c0.176 0.703 0.464 1.336 0.866 1.901 0.401 0.552 0.91 0.998 1.525 1.336 0.615 0.326 1.311 0.496 2.089 0.508 0.803 0.013 1.531-0.176 2.184-0.565 0.665-0.401 1.217-0.941 1.656-1.619l4.687 1.092c-0.766 1.669-1.908 3.037-3.426 4.104-1.518 1.054-3.219 1.581-5.101 1.581zM171.277 18.579h9.261c-0.138-0.753-0.433-1.431-0.885-2.033-0.439-0.615-0.985-1.104-1.638-1.468s-1.355-0.546-2.108-0.546-1.449 0.182-2.089 0.546c-0.64 0.351-1.186 0.835-1.638 1.449-0.439 0.602-0.741 1.286-0.904 2.052z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efede8",
    style: {
      fill: "var(--color2, #efede8)"
    },
    d: "M188.269 29.873l-0.019-18.824h4.593l0.019 1.675c0.64-0.678 1.404-1.211 2.296-1.6 0.89-0.402 1.85-0.602 2.88-0.602 0.689 0 1.38 0.1 2.071 0.301l-1.807 4.631c-0.478-0.188-0.954-0.282-1.431-0.282-0.742 0-1.419 0.182-2.033 0.546-0.602 0.351-1.086 0.834-1.449 1.449-0.352 0.602-0.527 1.274-0.527 2.014v10.692h-4.593z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efede8",
    style: {
      fill: "var(--color2, #efede8)"
    },
    d: "M202.221 29.873v-26.353h9.412c1.431 0 2.722 0.358 3.878 1.073 1.167 0.715 2.089 1.675 2.767 2.88s1.016 2.529 1.016 3.972c0 1.481-0.352 2.824-1.054 4.028-0.691 1.192-1.619 2.146-2.786 2.861-1.167 0.703-2.441 1.054-3.821 1.054h-4.819v10.485h-4.593zM206.814 14.795h4.329c0.651 0 1.248-0.163 1.788-0.489 0.538-0.326 0.966-0.765 1.28-1.318 0.326-0.552 0.489-1.167 0.489-1.845 0-0.69-0.164-1.311-0.489-1.864-0.314-0.552-0.742-0.991-1.28-1.318-0.54-0.326-1.137-0.489-1.788-0.489h-4.329v7.322z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efede8",
    style: {
      fill: "var(--color2, #efede8)"
    },
    d: "M221.248 22.908v-11.859h4.593v10.654c0 0.74 0.181 1.418 0.546 2.033 0.363 0.602 0.847 1.086 1.449 1.449 0.614 0.351 1.286 0.527 2.014 0.527 0.753 0 1.431-0.176 2.033-0.527 0.6-0.364 1.084-0.847 1.449-1.449 0.363-0.615 0.546-1.293 0.546-2.033v-10.654h4.593l0.019 18.824h-4.595l-0.017-1.713c-0.653 0.678-1.425 1.217-2.315 1.619-0.892 0.389-1.845 0.584-2.861 0.584-1.368 0-2.618-0.333-3.748-0.998-1.128-0.678-2.031-1.575-2.709-2.692-0.666-1.129-0.998-2.384-0.998-3.765z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efede8",
    style: {
      fill: "var(--color2, #efede8)"
    },
    d: "M242.368 29.873v-28.235h4.593v28.235h-4.593z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efede8",
    style: {
      fill: "var(--color2, #efede8)"
    },
    d: "M257.039 30.212c-0.979-0.063-1.928-0.257-2.842-0.584-0.904-0.339-1.707-0.797-2.409-1.374-0.704-0.577-1.242-1.267-1.619-2.071l3.878-1.656c0.151 0.251 0.395 0.521 0.734 0.809 0.339 0.276 0.74 0.508 1.205 0.696 0.476 0.188 0.998 0.282 1.562 0.282 0.476 0 0.928-0.063 1.355-0.188 0.439-0.138 0.791-0.345 1.054-0.621 0.275-0.276 0.414-0.634 0.414-1.073 0-0.464-0.164-0.822-0.489-1.073-0.314-0.264-0.715-0.458-1.205-0.584-0.478-0.138-0.941-0.264-1.393-0.376-1.193-0.238-2.304-0.609-3.332-1.111-1.016-0.502-1.839-1.148-2.466-1.939-0.616-0.803-0.922-1.769-0.922-2.899 0-1.242 0.326-2.315 0.979-3.219 0.664-0.904 1.525-1.6 2.579-2.089 1.065-0.489 2.214-0.734 3.445-0.734 1.493 0 2.861 0.314 4.104 0.941 1.254 0.615 2.246 1.487 2.974 2.616l-3.633 2.146c-0.177-0.301-0.422-0.577-0.734-0.828-0.314-0.264-0.672-0.477-1.073-0.64-0.403-0.176-0.823-0.276-1.261-0.301-0.565-0.025-1.080 0.025-1.544 0.151-0.465 0.125-0.841 0.339-1.129 0.64-0.277 0.301-0.414 0.703-0.414 1.205 0 0.477 0.188 0.834 0.565 1.073 0.376 0.226 0.828 0.402 1.355 0.527 0.538 0.125 1.054 0.264 1.544 0.414 1.103 0.364 2.138 0.809 3.106 1.336 0.979 0.527 1.762 1.173 2.353 1.939 0.589 0.766 0.872 1.681 0.847 2.748 0 1.217-0.365 2.284-1.092 3.2-0.728 0.904-1.67 1.594-2.824 2.071-1.143 0.477-2.366 0.665-3.671 0.565z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efede8",
    style: {
      fill: "var(--color2, #efede8)"
    },
    d: "M275.834 30.362c-1.732 0-3.313-0.446-4.744-1.336-1.419-0.891-2.554-2.089-3.407-3.595-0.841-1.506-1.261-3.169-1.261-4.988 0-1.368 0.245-2.648 0.734-3.84 0.489-1.205 1.16-2.259 2.014-3.162 0.866-0.916 1.869-1.631 3.012-2.146 1.141-0.515 2.359-0.772 3.652-0.772 1.468 0 2.81 0.314 4.028 0.941 1.229 0.615 2.27 1.462 3.125 2.541 0.853 1.079 1.474 2.309 1.864 3.689 0.388 1.38 0.476 2.824 0.264 4.329h-13.76c0.175 0.703 0.463 1.336 0.866 1.901 0.401 0.552 0.909 0.998 1.525 1.336 0.614 0.326 1.31 0.496 2.089 0.508 0.802 0.013 1.53-0.176 2.184-0.565 0.664-0.401 1.216-0.941 1.656-1.619l4.687 1.092c-0.766 1.669-1.909 3.037-3.426 4.104-1.519 1.054-3.219 1.581-5.101 1.581zM271.204 18.579h9.261c-0.139-0.753-0.433-1.431-0.885-2.033-0.44-0.615-0.986-1.104-1.638-1.468-0.653-0.364-1.355-0.546-2.108-0.546s-1.449 0.182-2.089 0.546c-0.64 0.351-1.186 0.835-1.638 1.449-0.44 0.602-0.742 1.286-0.904 2.052z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-logo-white",
    viewBox: "0 0 286 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#efede8",
    style: {
      fill: "var(--color1, #efede8)"
    },
    d: "M80.941 13.714c1.040 0 1.882 0.843 1.882 1.882v0.807c0 1.040-0.843 1.882-1.882 1.882h-2.151c-1.039 0-1.882 0.843-1.882 1.882v5.378c0 1.040-0.843 1.882-1.882 1.882h-2.151c-1.040 0-1.882 0.843-1.882 1.882v0.807c0 1.040-0.843 1.882-1.882 1.882h-5.109c-1.040 0-1.882-0.843-1.882-1.882v-9.95c0-1.040-0.843-1.882-1.882-1.882h-37.647c-1.040 0-1.882 0.843-1.882 1.882v9.95c0 1.040-0.843 1.882-1.882 1.882h-5.109c-1.040 0-1.882-0.843-1.882-1.882v-0.807c0-1.040-0.843-1.882-1.882-1.882h-2.151c-1.040 0-1.882-0.843-1.882-1.882v-5.378c0-1.040-0.843-1.882-1.882-1.882h-2.151c-1.040 0-1.882-0.843-1.882-1.882v-0.807c0-1.040 0.843-1.882 1.882-1.882h2.151c1.040 0 1.882-0.843 1.882-1.882v-5.378c0-1.040 0.843-1.882 1.882-1.882h2.151c1.040 0 1.882-0.843 1.882-1.882v-0.807c0-1.040 0.843-1.882 1.882-1.882h5.109c1.040 0 1.882 0.843 1.882 1.882v9.95c0 1.040 0.843 1.882 1.882 1.882h37.647c1.040 0 1.882-0.843 1.882-1.882v-9.95c0-1.040 0.843-1.882 1.882-1.882h5.109c1.040 0 1.882 0.843 1.882 1.882v0.807c0 1.040 0.843 1.882 1.882 1.882h2.151c1.040 0 1.882 0.843 1.882 1.882v5.378c0 1.040 0.843 1.882 1.882 1.882h2.151z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efede8",
    style: {
      fill: "var(--color1, #efede8)"
    },
    d: "M97.882 29.873v-26.353h9.412c1.431 0 2.723 0.358 3.878 1.073 1.167 0.715 2.089 1.675 2.767 2.88s1.016 2.529 1.016 3.972c0 1.481-0.351 2.824-1.054 4.028-0.69 1.192-1.619 2.146-2.786 2.861-1.167 0.703-2.441 1.054-3.821 1.054h-4.819v10.485h-4.593zM102.475 14.796h4.329c0.653 0 1.249-0.163 1.788-0.489s0.966-0.765 1.28-1.318c0.326-0.552 0.489-1.167 0.489-1.845 0-0.69-0.163-1.311-0.489-1.864-0.314-0.552-0.74-0.991-1.28-1.318s-1.136-0.489-1.788-0.489h-4.329v7.322z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efede8",
    style: {
      fill: "var(--color1, #efede8)"
    },
    d: "M125.393 30.363c-1.732 0-3.313-0.445-4.744-1.336-1.418-0.891-2.554-2.083-3.407-3.576-0.841-1.506-1.261-3.169-1.261-4.988 0-1.38 0.245-2.667 0.734-3.859 0.489-1.205 1.161-2.259 2.014-3.162 0.866-0.916 1.87-1.631 3.012-2.146s2.359-0.772 3.652-0.772c1.732 0 3.307 0.446 4.725 1.336 1.431 0.891 2.566 2.089 3.407 3.595 0.853 1.506 1.28 3.175 1.28 5.007 0 1.368-0.245 2.648-0.734 3.84s-1.167 2.246-2.033 3.162c-0.853 0.904-1.851 1.613-2.993 2.127-1.129 0.515-2.347 0.772-3.652 0.772zM125.393 25.77c0.916 0 1.738-0.245 2.466-0.734s1.299-1.136 1.713-1.939c0.427-0.803 0.64-1.681 0.64-2.635 0-0.979-0.219-1.87-0.659-2.673-0.427-0.816-1.010-1.462-1.751-1.939-0.728-0.489-1.531-0.734-2.409-0.734-0.904 0-1.719 0.245-2.447 0.734s-1.305 1.142-1.732 1.958c-0.427 0.816-0.64 1.7-0.64 2.654 0 0.991 0.22 1.889 0.659 2.692s1.023 1.443 1.751 1.92c0.741 0.464 1.544 0.696 2.409 0.696z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efede8",
    style: {
      fill: "var(--color1, #efede8)"
    },
    d: "M146.566 29.873h-4.555l-6.287-18.823h4.499l4.085 12.179 4.066-12.179h4.536l4.066 12.179 4.085-12.179h4.499l-6.287 18.823h-4.555l-4.085-12.235-4.066 12.235z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efede8",
    style: {
      fill: "var(--color1, #efede8)"
    },
    d: "M175.907 30.363c-1.732 0-3.313-0.445-4.744-1.336-1.418-0.891-2.554-2.089-3.407-3.595-0.841-1.506-1.261-3.169-1.261-4.988 0-1.368 0.245-2.648 0.734-3.84 0.489-1.205 1.161-2.259 2.014-3.162 0.866-0.916 1.87-1.631 3.012-2.146s2.359-0.772 3.652-0.772c1.468 0 2.811 0.314 4.028 0.941 1.23 0.615 2.271 1.462 3.125 2.541s1.474 2.309 1.864 3.689c0.389 1.38 0.477 2.823 0.264 4.329h-13.76c0.176 0.703 0.464 1.336 0.866 1.901 0.401 0.552 0.91 0.998 1.525 1.336 0.615 0.326 1.311 0.496 2.089 0.508 0.803 0.013 1.531-0.176 2.184-0.565 0.665-0.401 1.217-0.941 1.656-1.619l4.687 1.092c-0.766 1.669-1.908 3.037-3.426 4.104-1.518 1.054-3.219 1.581-5.101 1.581zM171.277 18.579h9.261c-0.138-0.753-0.433-1.431-0.885-2.033-0.439-0.615-0.985-1.104-1.638-1.468s-1.355-0.546-2.108-0.546-1.449 0.182-2.089 0.546c-0.64 0.351-1.186 0.835-1.638 1.449-0.439 0.602-0.741 1.286-0.904 2.052z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efede8",
    style: {
      fill: "var(--color1, #efede8)"
    },
    d: "M188.269 29.873l-0.019-18.823h4.593l0.019 1.675c0.64-0.678 1.404-1.211 2.296-1.6 0.89-0.402 1.85-0.602 2.88-0.602 0.689 0 1.38 0.1 2.071 0.301l-1.807 4.631c-0.478-0.188-0.954-0.282-1.431-0.282-0.742 0-1.419 0.182-2.033 0.546-0.602 0.351-1.086 0.834-1.449 1.449-0.352 0.602-0.527 1.274-0.527 2.014v10.692h-4.593z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efede8",
    style: {
      fill: "var(--color1, #efede8)"
    },
    d: "M202.221 29.873v-26.353h9.412c1.431 0 2.722 0.358 3.878 1.073 1.167 0.715 2.089 1.675 2.767 2.88s1.016 2.529 1.016 3.972c0 1.481-0.352 2.824-1.054 4.028-0.691 1.192-1.619 2.146-2.786 2.861-1.167 0.703-2.441 1.054-3.821 1.054h-4.819v10.485h-4.593zM206.814 14.796h4.329c0.651 0 1.248-0.163 1.788-0.489 0.538-0.326 0.966-0.765 1.28-1.318 0.326-0.552 0.489-1.167 0.489-1.845 0-0.69-0.164-1.311-0.489-1.864-0.314-0.552-0.742-0.991-1.28-1.318-0.54-0.326-1.137-0.489-1.788-0.489h-4.329v7.322z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efede8",
    style: {
      fill: "var(--color1, #efede8)"
    },
    d: "M221.248 22.908v-11.859h4.593v10.654c0 0.741 0.181 1.418 0.546 2.033 0.363 0.602 0.847 1.086 1.449 1.449 0.614 0.351 1.286 0.527 2.014 0.527 0.753 0 1.431-0.176 2.033-0.527 0.6-0.364 1.084-0.847 1.449-1.449 0.363-0.615 0.546-1.292 0.546-2.033v-10.654h4.593l0.019 18.824h-4.595l-0.017-1.713c-0.653 0.678-1.425 1.217-2.315 1.619-0.892 0.389-1.845 0.584-2.861 0.584-1.368 0-2.618-0.332-3.748-0.998-1.128-0.678-2.031-1.575-2.709-2.692-0.666-1.129-0.998-2.384-0.998-3.765z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efede8",
    style: {
      fill: "var(--color1, #efede8)"
    },
    d: "M242.368 29.873v-28.235h4.593v28.235h-4.593z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efede8",
    style: {
      fill: "var(--color1, #efede8)"
    },
    d: "M257.039 30.212c-0.979-0.063-1.928-0.257-2.842-0.584-0.904-0.339-1.707-0.797-2.409-1.374-0.704-0.577-1.242-1.267-1.619-2.071l3.878-1.656c0.151 0.251 0.395 0.521 0.734 0.809 0.339 0.276 0.74 0.508 1.205 0.696 0.476 0.188 0.998 0.282 1.562 0.282 0.476 0 0.928-0.063 1.355-0.188 0.439-0.138 0.791-0.345 1.054-0.621 0.275-0.276 0.414-0.634 0.414-1.073 0-0.464-0.164-0.822-0.489-1.073-0.314-0.264-0.715-0.458-1.205-0.584-0.478-0.138-0.941-0.264-1.393-0.376-1.193-0.238-2.304-0.609-3.332-1.111-1.016-0.502-1.839-1.148-2.466-1.939-0.616-0.803-0.922-1.769-0.922-2.899 0-1.242 0.326-2.315 0.979-3.219 0.664-0.904 1.525-1.6 2.579-2.089 1.065-0.489 2.214-0.734 3.445-0.734 1.493 0 2.861 0.314 4.104 0.941 1.254 0.615 2.246 1.487 2.974 2.616l-3.633 2.146c-0.177-0.301-0.422-0.577-0.734-0.828-0.314-0.264-0.672-0.477-1.073-0.64-0.403-0.176-0.823-0.276-1.261-0.301-0.565-0.025-1.080 0.025-1.544 0.151-0.465 0.125-0.841 0.339-1.129 0.64-0.277 0.301-0.414 0.703-0.414 1.205 0 0.477 0.188 0.834 0.565 1.073 0.376 0.226 0.828 0.402 1.355 0.527 0.538 0.125 1.054 0.264 1.544 0.414 1.103 0.364 2.138 0.809 3.106 1.336 0.979 0.527 1.762 1.173 2.353 1.939 0.589 0.766 0.872 1.682 0.847 2.748 0 1.217-0.365 2.284-1.092 3.2-0.728 0.904-1.67 1.594-2.824 2.071-1.143 0.477-2.366 0.665-3.671 0.565z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efede8",
    style: {
      fill: "var(--color1, #efede8)"
    },
    d: "M275.834 30.363c-1.732 0-3.313-0.445-4.744-1.336-1.419-0.891-2.554-2.089-3.407-3.595-0.841-1.506-1.261-3.169-1.261-4.988 0-1.368 0.245-2.648 0.734-3.84 0.489-1.205 1.16-2.259 2.014-3.162 0.866-0.916 1.869-1.631 3.012-2.146 1.141-0.515 2.359-0.772 3.652-0.772 1.468 0 2.81 0.314 4.028 0.941 1.229 0.615 2.27 1.462 3.125 2.541 0.853 1.079 1.474 2.309 1.864 3.689 0.388 1.38 0.476 2.823 0.264 4.329h-13.76c0.175 0.703 0.463 1.336 0.866 1.901 0.401 0.552 0.909 0.998 1.525 1.336 0.614 0.326 1.31 0.496 2.089 0.508 0.802 0.013 1.53-0.176 2.184-0.565 0.664-0.401 1.216-0.941 1.656-1.619l4.687 1.092c-0.766 1.669-1.909 3.037-3.426 4.104-1.519 1.054-3.219 1.581-5.101 1.581zM271.204 18.579h9.261c-0.139-0.753-0.433-1.431-0.885-2.033-0.44-0.615-0.986-1.104-1.638-1.468-0.653-0.364-1.355-0.546-2.108-0.546s-1.449 0.182-2.089 0.546c-0.64 0.351-1.186 0.835-1.638 1.449-0.44 0.602-0.742 1.286-0.904 2.052z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-logout",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e6533c",
    style: {
      stroke: "var(--color3, #e6533c)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.4,
    d: "M12 4h-1.6c-2.24 0-3.36 0-4.216 0.436-0.753 0.383-1.365 0.995-1.748 1.748-0.436 0.856-0.436 1.976-0.436 4.216v11.2c0 2.24 0 3.36 0.436 4.216 0.383 0.753 0.995 1.364 1.748 1.748 0.856 0.436 1.976 0.436 4.216 0.436h1.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e6533c",
    style: {
      stroke: "var(--color3, #e6533c)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.4,
    d: "M21.333 22.667l6.667-6.667M28 16l-6.667-6.667M28 16h-16"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-logout-white",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#efede8",
    style: {
      stroke: "var(--color1, #efede8)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.4,
    d: "M12 4h-1.6c-2.24 0-3.36 0-4.216 0.436-0.753 0.383-1.365 0.995-1.748 1.748-0.436 0.856-0.436 1.976-0.436 4.216v11.2c0 2.24 0 3.36 0.436 4.216 0.383 0.753 0.995 1.364 1.748 1.748 0.856 0.436 1.976 0.436 4.216 0.436h1.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#efede8",
    style: {
      stroke: "var(--color1, #efede8)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.4,
    d: "M21.333 22.667l6.667-6.667M28 16l-6.667-6.667M28 16h-16"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-settings",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#efede8",
    style: {
      stroke: "var(--color2, #efede8)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.2857,
    d: "M16 20c2.209 0 4-1.791 4-4s-1.791-4-4-4c-2.209 0-4 1.791-4 4s1.791 4 4 4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#efede8",
    style: {
      stroke: "var(--color2, #efede8)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.2857,
    d: "M24.969 19.636c-0.161 0.366-0.209 0.771-0.138 1.164s0.259 0.756 0.538 1.042l0.073 0.073c0.225 0.225 0.404 0.493 0.526 0.787s0.185 0.61 0.185 0.928-0.063 0.634-0.185 0.928c-0.122 0.294-0.301 0.562-0.526 0.787s-0.493 0.404-0.787 0.526c-0.294 0.122-0.61 0.185-0.928 0.185s-0.634-0.063-0.928-0.185c-0.294-0.122-0.562-0.301-0.787-0.526l-0.073-0.073c-0.286-0.279-0.648-0.467-1.042-0.538s-0.799-0.023-1.164 0.138c-0.358 0.154-0.664 0.409-0.88 0.734s-0.331 0.706-0.333 1.096v0.206c0 0.643-0.255 1.26-0.71 1.714s-1.071 0.71-1.714 0.71-1.26-0.255-1.714-0.71c-0.455-0.455-0.71-1.071-0.71-1.714v-0.109c-0.009-0.401-0.139-0.79-0.373-1.117s-0.56-0.575-0.936-0.713c-0.366-0.161-0.771-0.209-1.164-0.138s-0.756 0.259-1.042 0.538l-0.073 0.073c-0.225 0.225-0.492 0.404-0.787 0.526s-0.61 0.185-0.928 0.185-0.634-0.063-0.928-0.185c-0.294-0.122-0.562-0.301-0.787-0.526s-0.404-0.492-0.526-0.787c-0.122-0.294-0.185-0.61-0.185-0.928s0.063-0.634 0.185-0.928c0.122-0.294 0.301-0.562 0.526-0.787l0.073-0.073c0.279-0.286 0.467-0.649 0.538-1.042s0.023-0.799-0.138-1.164c-0.154-0.358-0.409-0.664-0.734-0.88s-0.706-0.331-1.096-0.333h-0.206c-0.643 0-1.26-0.255-1.714-0.71s-0.71-1.071-0.71-1.714 0.255-1.26 0.71-1.714c0.455-0.455 1.071-0.71 1.714-0.71h0.109c0.401-0.009 0.79-0.139 1.117-0.373s0.575-0.56 0.714-0.936c0.161-0.366 0.21-0.771 0.138-1.164s-0.259-0.756-0.538-1.042l-0.073-0.073c-0.225-0.225-0.404-0.492-0.526-0.787s-0.185-0.61-0.185-0.928c0-0.319 0.063-0.634 0.185-0.928s0.301-0.562 0.526-0.787c0.225-0.225 0.492-0.404 0.787-0.526s0.61-0.185 0.928-0.185c0.319 0 0.634 0.063 0.928 0.185s0.562 0.301 0.787 0.526l0.073 0.073c0.286 0.279 0.649 0.467 1.042 0.538s0.799 0.023 1.164-0.138h0.097c0.358-0.154 0.664-0.409 0.88-0.734s0.331-0.706 0.333-1.096v-0.206c0-0.643 0.255-1.26 0.71-1.714s1.071-0.71 1.714-0.71 1.26 0.255 1.714 0.71c0.455 0.455 0.71 1.071 0.71 1.714v0.109c0.002 0.39 0.117 0.771 0.332 1.096s0.521 0.58 0.88 0.734c0.366 0.161 0.771 0.209 1.164 0.138s0.756-0.259 1.042-0.538l0.073-0.073c0.225-0.225 0.493-0.404 0.787-0.526s0.61-0.185 0.928-0.185c0.319 0 0.634 0.063 0.928 0.185s0.562 0.301 0.787 0.526c0.226 0.225 0.404 0.492 0.526 0.787s0.185 0.61 0.185 0.928-0.063 0.634-0.185 0.928c-0.122 0.294-0.301 0.562-0.526 0.787l-0.073 0.073c-0.279 0.286-0.467 0.649-0.538 1.042s-0.023 0.799 0.138 1.164v0.097c0.154 0.358 0.409 0.664 0.734 0.88s0.706 0.331 1.096 0.333h0.206c0.643 0 1.26 0.255 1.714 0.71s0.71 1.071 0.71 1.714-0.255 1.26-0.71 1.714c-0.455 0.455-1.071 0.71-1.714 0.71h-0.109c-0.39 0.002-0.771 0.117-1.096 0.332s-0.58 0.521-0.734 0.88z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-mobile-menu",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e6533c",
    style: {
      stroke: "var(--color3, #e6533c)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M4 16h16M4 8h24M4 24h24"
  })), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-close",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.4615,
    d: "M24 8l-16 16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.4615,
    d: "M8 8l16 16"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-warning",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M16 25.333v0.013M16 20v-13.333"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-add-avatar",
    viewBox: "0 0 33 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e6533c",
    style: {
      fill: "var(--color3, #e6533c)"
    },
    d: "M11.238 0.428l4.69 1.356c0.339 0.098 0.699 0.099 1.038 0.002l4.83-1.375c0.845-0.241 1.744 0.136 2.166 0.906l2.506 4.577c0.168 0.307 0.419 0.561 0.723 0.734l3.986 2.258c0.771 0.437 1.133 1.352 0.869 2.198l-1.381 4.428c-0.113 0.363-0.114 0.752-0.002 1.115l1.394 4.521c0.258 0.836-0.094 1.739-0.849 2.18l-4.443 2.597c-0.303 0.177-0.551 0.436-0.715 0.746l-2.114 4.004c-0.409 0.775-1.298 1.165-2.145 0.941l-4.863-1.284c-0.317-0.084-0.651-0.083-0.968 0.002l-4.715 1.264c-0.867 0.232-1.777-0.179-2.175-0.983l-2.106-4.256c-0.177-0.357-0.462-0.649-0.816-0.834l-4.304-2.247c-0.786-0.411-1.179-1.314-0.943-2.169l1.255-4.548c0.089-0.322 0.090-0.662 0.005-0.985l-1.288-4.843c-0.221-0.833 0.151-1.71 0.904-2.129l4.422-2.46c0.322-0.179 0.584-0.448 0.754-0.775l2.090-4.007c0.414-0.794 1.331-1.187 2.192-0.938z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#efede8",
    style: {
      stroke: "var(--color2, #efede8)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M16.5 10.75v10.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#efede8",
    style: {
      stroke: "var(--color2, #efede8)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M11.25 16h10.5"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-avatar",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#efede8",
    style: {
      fill: "var(--color2, #efede8)"
    },
    opacity: 0.1,
    d: "M16 5.333c1.415 0 2.771 0.562 3.771 1.562s1.562 2.357 1.562 3.771-0.562 2.771-1.562 3.771c-1 1-2.357 1.562-3.771 1.562s-2.771-0.562-3.771-1.562c-1-1-1.562-2.357-1.562-3.771s0.562-2.771 1.562-3.771c1-1 2.357-1.562 3.771-1.562zM16 26.667c0 0 10.667 0 10.667-2.667 0-3.2-5.2-6.667-10.667-6.667s-10.667 3.467-10.667 6.667c0 2.667 10.667 2.667 10.667 2.667z"
  })), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 15.830666 17.498945",
    id: "icon-fluent-food"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.9974 2.5C15.2015 2.50003 15.3985 2.57496 15.551 2.7106C15.7036 2.84623 15.801 3.03312 15.8249 3.23583L15.8307 3.33333V16.6667C15.8305 16.8791 15.7492 17.0834 15.6034 17.2378C15.4575 17.3923 15.2583 17.4852 15.0462 17.4976C14.8342 17.5101 14.6254 17.4411 14.4625 17.3048C14.2997 17.1685 14.195 16.9751 14.1699 16.7642L14.1641 16.6667V12.5H13.3307C13.1266 12.5 12.9296 12.425 12.7771 12.2894C12.6246 12.1538 12.5271 11.9669 12.5032 11.7642L12.4974 11.6667V6.66667C12.4974 4.825 13.7474 2.5 14.9974 2.5ZM9.9974 2.5C10.2015 2.50003 10.3985 2.57496 10.551 2.7106C10.7036 2.84623 10.801 3.03312 10.8249 3.23583L10.8307 3.33333V7.5C10.8306 8.23906 10.585 8.95715 10.1325 9.54148C9.68003 10.1258 9.04625 10.5433 8.33073 10.7283V16.6667C8.33049 16.8791 8.24916 17.0834 8.10336 17.2378C7.95755 17.3923 7.75827 17.4852 7.54623 17.4976C7.3342 17.5101 7.12541 17.4411 6.96254 17.3048C6.79966 17.1685 6.69498 16.9751 6.6699 16.7642L6.66406 16.6667V10.7283C5.97694 10.5507 5.3644 10.1585 4.91553 9.60876C4.46666 9.05903 4.20487 8.38043 4.16823 7.67167L4.16406 7.5V3.33333C4.1643 3.12093 4.24563 2.91664 4.39144 2.76219C4.53724 2.60775 4.73652 2.5148 4.94856 2.50236C5.16059 2.48991 5.36938 2.5589 5.53226 2.69522C5.69513 2.83155 5.79981 3.02492 5.8249 3.23583L5.83073 3.33333V7.5C5.83074 7.79255 5.90775 8.07995 6.05403 8.33331C6.20031 8.58667 6.4107 8.79706 6.66406 8.94333V3.33333C6.6643 3.12093 6.74563 2.91664 6.89144 2.76219C7.03724 2.60775 7.23652 2.5148 7.44856 2.50236C7.66059 2.48991 7.86938 2.5589 8.03226 2.69522C8.19513 2.83155 8.29981 3.02492 8.3249 3.23583L8.33073 3.33333L8.33156 8.94333C8.56412 8.80891 8.76073 8.62027 8.90467 8.39349C9.0486 8.1667 9.13559 7.90848 9.15823 7.64083L9.16406 7.5V3.33333C9.16406 3.11232 9.25186 2.90036 9.40814 2.74408C9.56442 2.5878 9.77638 2.5 9.9974 2.5Z",
    fill: "#EF8964"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 20 17",
    id: "icon-dumbbell"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.25 5H1.75C1.33438 5 1 5.33437 1 5.75V9H0.25C0.1125 9 0 9.1125 0 9.25V10.75C0 10.8875 0.1125 11 0.25 11H1V14.25C1 14.6656 1.33438 15 1.75 15H3.25C3.66563 15 4 14.6656 4 14.25V5.75C4 5.33437 3.66563 5 3.25 5ZM19.75 9H19V5.75C19 5.33437 18.6656 5 18.25 5H16.75C16.3344 5 16 5.33437 16 5.75V14.25C16 14.6656 16.3344 15 16.75 15H18.25C18.6656 15 19 14.6656 19 14.25V11H19.75C19.8875 11 20 10.8875 20 10.75V9.25C20 9.1125 19.8875 9 19.75 9ZM14.25 3H12.75C12.3344 3 12 3.33437 12 3.75V9H8V3.75C8 3.33437 7.66563 3 7.25 3H5.75C5.33437 3 5 3.33437 5 3.75V16.25C5 16.6656 5.33437 17 5.75 17H7.25C7.66563 17 8 16.6656 8 16.25V11H12V16.25C12 16.6656 12.3344 17 12.75 17H14.25C14.6656 17 15 16.6656 15 16.25V3.75C15 3.33437 14.6656 3 14.25 3Z",
    fill: "#EF8964"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16.833632 17.816992",
    id: "icon-apple"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.1582 2.97399C12.2222 2.9546 12.2817 2.92257 12.3331 2.8798C12.3844 2.83703 12.4267 2.7844 12.4574 2.725C12.4881 2.6656 12.5066 2.60065 12.5117 2.534C12.5169 2.46734 12.5086 2.40032 12.4874 2.33692C12.4662 2.27351 12.4325 2.215 12.3883 2.16485C12.3441 2.1147 12.2903 2.07392 12.23 2.04493C12.1698 2.01594 12.1043 1.99933 12.0375 1.99608C11.9708 1.99282 11.904 2.00299 11.8412 2.02599C10.9032 2.33799 10.3192 3.10799 9.97524 3.93299C9.92905 4.04451 9.88669 4.15757 9.84824 4.27199C9.66091 3.91713 9.42122 3.59249 9.13724 3.30899C8.75287 2.92379 8.29377 2.62129 7.78818 2.42009C7.28258 2.21888 6.74117 2.12322 6.19724 2.13899C5.61724 2.15499 5.15424 2.61899 5.13824 3.19799C5.12247 3.74192 5.21813 4.28333 5.41934 4.78893C5.62054 5.29452 5.92304 5.75362 6.30824 6.13799L6.33924 6.16799C5.49923 6.34995 4.74012 6.7975 4.17425 7.44442C3.60838 8.09133 3.26581 8.90324 3.19724 9.75999L3.19124 9.83399C3.05922 11.4812 3.4102 13.1311 4.20124 14.582L4.56124 15.24C4.57124 15.257 4.58124 15.274 4.59324 15.29L5.59324 16.692C5.81988 17.0094 6.11296 17.2736 6.45207 17.4663C6.79119 17.6589 7.16821 17.7754 7.5569 17.8076C7.94559 17.8397 8.33662 17.7868 8.7028 17.6525C9.06897 17.5183 9.40149 17.3058 9.67724 17.03C9.71958 16.9876 9.76986 16.954 9.82519 16.9311C9.88053 16.9082 9.93984 16.8964 9.99974 16.8964C10.0596 16.8964 10.1189 16.9082 10.1743 16.9311C10.2296 16.954 10.2799 16.9876 10.3222 17.03C10.598 17.3058 10.9305 17.5183 11.2967 17.6525C11.6629 17.7868 12.0539 17.8397 12.4426 17.8076C12.8313 17.7754 13.2083 17.6589 13.5474 17.4663C13.8865 17.2736 14.1796 17.0094 14.4062 16.692L15.4062 15.291C15.4179 15.2746 15.4286 15.2576 15.4382 15.24L15.7972 14.582C16.5883 13.1311 16.9393 11.4812 16.8072 9.83399L16.8022 9.75999C16.758 9.20777 16.5995 8.67077 16.3368 8.18301C16.0742 7.69525 15.7131 7.26737 15.2764 6.92648C14.8397 6.58559 14.3369 6.33913 13.8 6.20271C13.2631 6.06629 12.7037 6.04289 12.1572 6.13399L10.5002 6.40999C10.5102 5.72899 10.6302 4.96299 10.8992 4.31699C11.1792 3.64199 11.5952 3.16199 12.1572 2.97399H12.1582ZM6.90824 8.97399C6.75471 9.02253 6.61232 9.10098 6.48926 9.20481C6.3662 9.30865 6.26491 9.43582 6.19124 9.57899C6.00624 9.92699 5.87924 10.501 5.99624 11.438C6.00936 11.5679 5.97115 11.6978 5.88979 11.7999C5.80842 11.902 5.69034 11.9682 5.56079 11.9844C5.43124 12.0006 5.30049 11.9655 5.19649 11.8865C5.09249 11.8076 5.02349 11.6911 5.00424 11.562C4.87124 10.498 4.99424 9.69699 5.30924 9.10799C5.62924 8.50799 6.11624 8.18399 6.59224 8.02499C6.65455 8.00424 6.72034 7.99597 6.78585 8.00064C6.85136 8.00532 6.9153 8.02285 6.97404 8.05224C7.03277 8.08163 7.08514 8.1223 7.12815 8.17193C7.17117 8.22156 7.20399 8.27918 7.22474 8.34149C7.24549 8.4038 7.25376 8.46959 7.24908 8.5351C7.24441 8.60061 7.22687 8.66455 7.19748 8.72329C7.16809 8.78202 7.12742 8.83439 7.07779 8.8774C7.02816 8.92042 6.97055 8.95324 6.90824 8.97399Z",
    fill: "#EF8964"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 17.848 20",
    id: "icon-calories"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.99898 13.9321C9.40789 14.382 8.1875 15.4946 8.1875 17.0105C8.1875 18.0112 8.99969 18.8254 9.99805 18.8254C10.9964 18.8254 11.8086 18.0112 11.8086 17.0105C11.8086 15.5749 10.5875 14.41 9.99898 13.9321Z",
    fill: "#EF8964"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.2437 3.48096C14.0241 3.23264 13.6452 3.2176 13.4061 3.4408L10.6488 6.0142V0.624943C10.6488 0.173811 10.1049 -0.163259 9.69754 0.0831466C9.62043 0.129787 7.78809 1.24869 5.93664 3.28061C3.68551 5.75123 2.15234 8.75939 2.15234 12.133C2.15234 16.4709 5.67293 20 10.0003 20C8.35574 20 7.01785 18.6588 7.01785 17.0103C7.01785 14.3466 9.6041 12.7693 9.71418 12.7034C9.90715 12.5881 10.1488 12.5935 10.3364 12.7171C10.4445 12.7883 12.9827 14.4908 12.9827 17.0103C12.9827 18.6588 11.6448 20 10.0003 20C14.3276 20 17.8482 16.4709 17.8482 12.133C17.8482 8.85744 16.4028 5.92154 14.2437 3.48096Z",
    fill: "#EF8964"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 17.269333 18.333334",
    id: "icon-bubble"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.9938 10.2163C15.3548 10.2163 17.2688 8.30228 17.2688 5.94126C17.2688 3.58025 15.3548 1.66626 12.9938 1.66626C10.6327 1.66626 8.71875 3.58025 8.71875 5.94126C8.71875 8.30228 10.6327 10.2163 12.9938 10.2163Z",
    fill: "#EF8964"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.29712 16.1994C6.71465 16.1994 7.8638 15.0502 7.8638 13.6327C7.8638 12.2152 6.71465 11.066 5.29712 11.066C3.87959 11.066 2.73047 12.2152 2.73047 13.6327C2.73047 15.0502 3.87959 16.1994 5.29712 16.1994Z",
    fill: "#EF8964"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.8443 18.3328C15.0225 18.3328 15.9776 17.3777 15.9776 16.1995C15.9776 15.0213 15.0225 14.0662 13.8443 14.0662C12.6661 14.0662 11.7109 15.0213 11.7109 16.1995C11.7109 17.3777 12.6661 18.3328 13.8443 18.3328Z",
    fill: "#EF8964"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 20 18",
    id: "icon-runner"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.5263 5.90673C18.2643 5.59374 17.7975 5.55259 17.4845 5.81359L15.4333 7.53667L14.49 5.19953C14.4564 5.1118 14.4055 5.03816 14.347 4.97318C14.1542 4.5443 13.8196 4.17608 13.3582 3.96272C13.1579 3.87175 12.951 3.82302 12.7441 3.79919C12.6987 3.77536 12.6575 3.74396 12.6055 3.72771L8.99583 2.72159C8.79331 2.66636 8.58971 2.7021 8.42292 2.79957C8.22473 2.86672 8.0547 3.01076 7.97347 3.21978L6.61429 6.71466C6.467 7.0948 6.65544 7.52367 7.03666 7.67313C7.41572 7.82042 7.84567 7.63089 7.99405 7.24967L9.14204 4.29846L10.7861 4.75549C10.746 4.82047 10.7027 4.88112 10.6702 4.95043L8.56263 9.51858C8.53231 9.58573 8.51606 9.65396 8.4944 9.72327L5.93307 14.0174L1.64651 15.4513C1.16132 15.8141 1.05843 16.4975 1.41691 16.9827C1.77755 17.469 2.4631 17.5719 2.94721 17.2134L7.33341 15.7026C7.4677 15.6051 7.56518 15.4773 7.63882 15.3398C7.69405 15.2813 7.75687 15.2347 7.79911 15.1622L9.32615 12.6019L12.0369 14.912L9.13663 18.1805C8.737 18.6311 8.77707 19.3253 9.22976 19.7238C9.68138 20.1256 10.3734 20.0834 10.7752 19.6307L14.3947 15.5531C14.5073 15.4275 14.5744 15.2824 14.6199 15.1308C14.647 15.0484 14.647 14.9629 14.6535 14.8773C14.6535 14.834 14.6697 14.795 14.6665 14.7549C14.6567 14.456 14.5354 14.1658 14.2907 13.9589L11.7965 11.8319C11.9763 11.6608 12.129 11.4572 12.2395 11.2178L13.8553 7.71861L14.373 9.09729C14.3947 9.21967 14.4358 9.33988 14.5224 9.4406C14.6004 9.53374 14.7001 9.59547 14.8062 9.6388C14.817 9.64421 14.83 9.64529 14.843 9.64854C14.9102 9.67237 14.9784 9.69511 15.0488 9.69836C15.1322 9.70594 15.2167 9.69511 15.3022 9.67129C15.3044 9.6702 15.3055 9.6702 15.3055 9.6702C15.3282 9.66479 15.351 9.66912 15.3737 9.65937C15.4939 9.61389 15.586 9.53699 15.665 9.4471L18.6087 6.94859C18.9216 6.68542 18.7895 6.21972 18.5263 5.90673Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.8053 4.12628C15.9448 4.12628 16.8685 3.20258 16.8685 2.06314C16.8685 0.923699 15.9448 0 14.8053 0C13.6659 0 12.7422 0.923699 12.7422 2.06314C12.7422 3.20258 13.6659 4.12628 14.8053 4.12628Z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-pagination",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e6533c",
    style: {
      stroke: "var(--color1, #e6533c)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2.2857,
    d: "M30.857 16c0 8.205-6.652 14.857-14.857 14.857s-14.857-6.652-14.857-14.857c0-8.205 6.652-14.857 14.857-14.857s14.857 6.652 14.857 14.857z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6533c",
    style: {
      fill: "var(--color1, #e6533c)"
    },
    d: "M25.143 16c0 5.049-4.093 9.143-9.143 9.143s-9.143-4.093-9.143-9.143c0-5.049 4.093-9.143 9.143-9.143s9.143 4.093 9.143 9.143z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-right",
    viewBox: "0 0 42 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e6533c",
    style: {
      stroke: "var(--color3)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 4.8,
    d: "M23.467 29.333l13.333-13.333M36.8 16l-13.333-13.333M36.8 16h-32"
  })), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-close",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.4615,
    d: "M24 8l-16 16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.4615,
    d: "M8 8l16 16"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-run",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#efa082",
    style: {
      fill: "var(--color1, #efa082)"
    },
    d: "M32 16c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efede8",
    style: {
      fill: "var(--color2, #efede8)"
    },
    d: "M25.099 11.634c-0.281-0.334-0.779-0.378-1.112-0.099l-2.187 1.838-1.008-2.493c-0.034-0.094-0.089-0.172-0.151-0.241-0.206-0.457-0.563-0.85-1.055-1.078-0.214-0.097-0.435-0.149-0.656-0.174-0.047-0.025-0.091-0.059-0.149-0.076l-3.849-1.073c-0.216-0.059-0.432-0.021-0.612 0.083-0.211 0.072-0.393 0.225-0.479 0.448l-1.451 3.728c-0.156 0.405 0.044 0.863 0.451 1.022 0.406 0.157 0.865-0.045 1.023-0.452l1.224-3.148 1.753 0.487c-0.042 0.069-0.089 0.134-0.122 0.208l-2.25 4.873c-0.031 0.072-0.049 0.144-0.070 0.218l-2.734 4.58-4.57 1.529c-0.518 0.387-0.628 1.116-0.245 1.633 0.383 0.519 1.115 0.629 1.63 0.246l4.68-1.612c0.143-0.104 0.247-0.24 0.326-0.387 0.060-0.062 0.125-0.112 0.172-0.189l1.628-2.731 2.893 2.464-3.094 3.486c-0.427 0.481-0.385 1.221 0.099 1.646 0.482 0.429 1.219 0.384 1.648-0.099l3.859-4.349c0.12-0.134 0.193-0.289 0.242-0.451 0.029-0.088 0.029-0.179 0.034-0.27 0-0.046 0.018-0.088 0.016-0.131-0.010-0.319-0.141-0.628-0.401-0.849l-2.661-2.269c0.193-0.183 0.354-0.4 0.471-0.655l1.724-3.733 0.552 1.471c0.023 0.131 0.068 0.259 0.161 0.366 0.083 0.099 0.187 0.165 0.302 0.211 0.010 0.006 0.026 0.007 0.039 0.010 0.070 0.025 0.143 0.050 0.219 0.053 0.089 0.008 0.18-0.003 0.271-0.029 0.003-0.001 0.003-0.001 0.003-0.001 0.026-0.006 0.049-0.001 0.073-0.012 0.13-0.048 0.227-0.131 0.313-0.226l3.138-2.665c0.336-0.281 0.193-0.777-0.086-1.111z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efede8",
    style: {
      fill: "var(--color2, #efede8)"
    },
    d: "M23.325 7.534c0 1.215-0.984 2.201-2.2 2.201s-2.201-0.985-2.201-2.201 0.984-2.201 2.201-2.201c1.216 0 2.2 0.985 2.2 2.201z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "Pause",
    viewBox: "0 0 29 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#efede8",
    style: {
      stroke: "var(--color1, #efede8)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 4.16,
    d: "M3.731 28.8v-25.6M25.065 28.8v-25.6"
  })), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 8 13",
    id: "Polygon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M9 6L0 11.1962V0.803848L9 6Z",
    fill: "#EFEDE8"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 15.750667 15.750667",
    id: "icon-Search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.25 14.25C11.5637 14.25 14.25 11.5637 14.25 8.25C14.25 4.93629 11.5637 2.25 8.25 2.25C4.93629 2.25 2.25 4.93629 2.25 8.25C2.25 11.5637 4.93629 14.25 8.25 14.25Z",
    stroke: "#EFEDE8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.7508 15.75L12.4883 12.4875",
    stroke: "#EFEDE8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 20 20",
    fill: "none",
    id: "icon-trash"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Accent",
    d: "M7.5 2.5H12.5M8.33333 8.75V12.9167M11.6667 8.75V12.9167",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M2.5 5H17.5M15.8333 5L15.2489 13.7661C15.1612 15.0813 15.1174 15.7389 14.8333 16.2375C14.5833 16.6765 14.206 17.0294 13.7514 17.2497C13.235 17.5 12.5759 17.5 11.2578 17.5H8.74221C7.42409 17.5 6.76503 17.5 6.24861 17.2497C5.79396 17.0294 5.41674 16.6765 5.16665 16.2375C4.88259 15.7389 4.83875 15.0813 4.75107 13.7661L4.16667 5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 17.5 18.333334",
    id: "icon-calendar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.8333 3.33337H4.16667C3.24619 3.33337 2.5 4.07957 2.5 5.00004V16.6667C2.5 17.5872 3.24619 18.3334 4.16667 18.3334H15.8333C16.7538 18.3334 17.5 17.5872 17.5 16.6667V5.00004C17.5 4.07957 16.7538 3.33337 15.8333 3.33337Z",
    stroke: "#EF8964",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.332 1.66663V4.99996",
    stroke: "#EF8964",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.66797 1.66663V4.99996",
    stroke: "#EF8964",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M2.5 8.33337H17.5",
    stroke: "#EF8964",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 12.664001 14.957334",
    id: "icon-chevron"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 2 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.45718 14.9572L4.04297 13.5429L9.83586 7.75005L4.04297 1.95715L5.45718 0.542938L12.6643 7.75005L5.45718 14.9572Z",
    fill: "#EFEDE8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.7ff223f3f81f61e0861ded119343f344.svg";
export { ForwardRef as ReactComponent };